module.exports = __webpack_public_path__ + "assetsclientes/img/hombre.6aa51595.svg";